import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setResponse } from "Slices/Response/responseSlice";
import { setToast, setLoading, setModal } from "Slices/uiSlice";
import { UploadFileS3 } from "Slices/File/fileSlice";
import { getTutorial, adminTutorial } from "Services/tutorial_service";
import { fileUri } from "Constantes/constants";

const initialState = {
    contenido: [],
    slide: {
        idContenidoTutorial: 0,
        titulo: '',
        file: null,
        descripcion: '',
        archivo: '',
    },
}

export const tutorialSlice = createSlice({
    name: 'tutorial',
    initialState,
    reducers: {
        setContenido: (state, action) => {
            state.contenido = action.payload;
        },
        setSlide: (state, action) => {
            state.slide = action.payload ?? initialState.slide;
        },
        updateTutorialField: (state, action) => {
            const { name, value } = action.payload;
            state.slide[name] = value;
        },
    }
});

export const fetchTutorial = createAsyncThunk(
    'tutorial/fetchTutorial',
    async (_, { dispatch }) => {
        const tutorialRes = await getTutorial();
        dispatch(setContenido(tutorialRes));
    }
);

export const mergeSlide = createAsyncThunk(
    'tutorial/merge',
    async (data, { dispatch }) => {
        dispatch(setLoading(true))
        const tutorialRes = await adminTutorial(data);

        if (data.file) {
            const formData = new FormData();
            formData.append('file', data.file);
            formData.append('tipo', fileUri.portada);
            await dispatch(UploadFileS3(formData));
        }

        dispatch(setResponse(tutorialRes));
        dispatch(setSlide(initialState.slide));
        dispatch(setLoading(false));
        dispatch(setModal(false));
        dispatch(setToast(true));
        dispatch(fetchTutorial());
        setTimeout(() => {
            dispatch(setToast(false));
        }, 3000);
    }
);

export const { setContenido, setSlide, updateTutorialField } = tutorialSlice.actions;
export default tutorialSlice.reducer;